import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6qmzxvyma9: FaireBrandEntity = {
  token: "b_6qmzxvyma9",
  type: "brand",
  name: "Wild Roots Tallow Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/4a9ae828cfb6aca2124beeb9ceea887eb3df017d8383dd9a2041d791ddcd675a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/34baf19336b1173d850e27a7d8353b86c3fa36f82fc513df16a677e282bca83d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4a9ae828cfb6aca2124beeb9ceea887eb3df017d8383dd9a2041d791ddcd675a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/34baf19336b1173d850e27a7d8353b86c3fa36f82fc513df16a677e282bca83d.jpeg",
  location: "Yakima , WA, USA",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 30,
  isTopShop: true,
  isInsider: true,
  description:
    "We are dedicated to making all of our products in small batches by hand. We incorporate ingredients that are superior in quality and therapeutic value in order to provide our customers with not only the most luxurious tallow balms available, but also the most nourishing, healing, and hydrating skincare products you will ever put on your skin.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:58.768Z",
    importedBy: "entity-db-cli",
  },
};
